import { apiUrl } from "../config/app";
import ApiService from "./ApiService";

export const fetchFormDropdowns = async (id: string = "") => {
  const apiService = new ApiService();
  const url = apiUrl + "/form-dropdowns" + (id ? "/" + id : "");
  const resp = await apiService.get(url);
  console.log("formDropdowns fetched ", resp);
  return resp;
};

export const upsertFormDropdown = async (data: any) => {
  const apiService = new ApiService();
  const url = apiUrl + "/form-dropdowns";
  const resp = await apiService.post(url, data);
  console.log("formDropdown saved ", resp);
  return resp;
};

export const updateFormDropdownBulk = async (data: any) => {
  const apiService = new ApiService();
  const url = apiUrl + "/form-dropdowns/bulk";
  const resp = await apiService.post(url, data);
  console.log("formDropdowns bulk ", resp);
  return resp;
};
